module.exports = __webpack_public_path__ + "img/info.ec4bbec6.svg";